var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0799 12C16.0799 13.98 14.4799 15.58 12.4999 15.58C10.5199 15.58 8.91992 13.98 8.91992 12C8.91992 10.02 10.5199 8.42 12.4999 8.42C14.4799 8.42 16.0799 10.02 16.0799 12Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 20.27C16.0298 20.27 19.3198 18.19 21.6098 14.59C22.5098 13.18 22.5098 10.81 21.6098 9.4C19.3198 5.8 16.0298 3.72 12.4998 3.72C8.96984 3.72 5.67984 5.8 3.38984 9.4C2.48984 10.81 2.48984 13.18 3.38984 14.59C5.67984 18.19 8.96984 20.27 12.4998 20.27Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.783a092a816d04c6671c968e1693a4bc.svg";
export { ForwardRef as ReactComponent };